'use strict';

import { APIResponse } from "../APITypes";
import { csrfHeaders } from '../csrf';

export default class SurveyResponseEndpoint {
    static async SubmitBulk(bulkSurvey: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/survey/bulk',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(bulkSurvey)
                }
            );
        
        if(!response.ok) {
            throw new Error("Submit bulk survey failed.");
        }
        return await response.json();
    }

    static async GetAllByEvent(course_event_id: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/survey/get-event',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify({course_event_id: course_event_id})
                }
            );
        
        if(!response.ok) {
            throw new Error("Get surveys for event failed.");
        }
        return await response.json();
    }

    static async Submit(survey: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/survey/submit',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(survey)
                }
            );
        
        if(!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Error occurred while submitting survey.");
        }
        return await response.json();
    }
}